import React, { useEffect, useRef } from "react";
import Draggable from "react-draggable";

function DraggableVideo({ currentVideoStream, currentAudioStream }) {
  const videoRef = useRef(null);

  useEffect(() => {
    if (currentVideoStream && currentAudioStream) {
      const combinedStream = new MediaStream([
        ...currentVideoStream.getVideoTracks(),
        ...currentAudioStream.getAudioTracks(),
      ]);

      if (videoRef.current) {
        videoRef.current.srcObject = combinedStream;
      }
    }
  }, [currentVideoStream, currentAudioStream]);

  return (
    <Draggable bounds="parent" scale={1}>
      <div
        style={{
          width: "270px",
          position: "absolute",
          cursor: "pointer",
          zIndex: 10,
          top: "18%",
          right: "7px",
        }}
      >
        <video
          ref={videoRef}
          autoPlay
          style={{
            borderRadius: "8px",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.3)",
            objectFit: "cover",
            objectPosition: "center",
          }}
        >
          Your browser does not support the video tag.
        </video>
      </div>
    </Draggable>
  );
}

export default DraggableVideo;
